<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <status-select v-model="filters.status" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column prop="id" label="编号"></el-table-column>

      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status | status }}
        </template>
      </el-table-column>

      <el-table-column prop="title" label="标题"></el-table-column>

      <el-table-column prop="price" label="价格"></el-table-column>

      <el-table-column prop="endTime" label="结束时间">
        <template slot-scope="scope">
          {{ scope.row.endTime | formatDate }}
        </template>
      </el-table-column>

      <el-table-column prop="endTime" label="支付结束时间">
        <template slot-scope="scope">
          <span v-if="scope.row.payEndTime > 0">{{ scope.row.payEndTime | formatDate }}</span>
          <span v-else>不限制</span>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDate }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="success" @click="preview(scope.$index, scope.row)"
            >预览</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="false"
      :close-on-press-escape="false"
      fullscreen
    >
      <el-form :key="addFormKey" ref="addForm" :model="addForm" label-position="top">
        <el-form-item label="标题">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <status-select v-model="addForm.status" />
        </el-form-item>

        <el-form-item label="结束时间">
          <el-date-picker
            v-model="addForm.endTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="支付结束时间">
          <el-date-picker
            v-model="addForm.payEndTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="内容">
          <html-editor v-model="addForm.content" />
        </el-form-item>

        <el-form-item label="邮件内容">
          <html-editor v-model="addForm.emailContent" />
        </el-form-item>

        <el-form-item label="表单配置">
          <el-input v-model="addForm.formConfig" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="false"
      :close-on-press-escape="false"
      fullscreen
    >
      <el-form :key="editFormKey" ref="editForm" label-position="top" :model="editForm">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="标题：">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>

        <el-form-item label="状态：">
          <status-select v-model="editForm.status" />
        </el-form-item>

        <el-form-item label="结束时间：">
          <el-date-picker
            v-model="editForm.endTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="支付结束时间：">
          <el-date-picker
            v-model="editForm.payEndTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="价格：">
          <el-input-number v-model="editForm.price"></el-input-number>
        </el-form-item>

        <el-form-item label="是否自动发送支付邮件：">
          <!-- <el-input-number v-model="editForm.price"></el-input-number> -->
          <el-select v-model="editForm.autoSendEmail" placeholder="是否自动发送支付邮件">
            <el-option label="自动发送支付邮件" :value="true" />
            <el-option label="不发送" :value="false" />
          </el-select>
        </el-form-item>

        <el-form-item label="内容：">
          <html-editor v-model="editForm.content" />
        </el-form-item>

        <el-form-item label="活动参与成功邮件内容：">
          <html-editor v-model="editForm.emailContent" />
        </el-form-item>

        <el-form-item label="表单配置：">
          <el-input v-model="editForm.formConfig" type="textarea" :rows="6"></el-input>
        </el-form-item>

        <el-form-item label="支付提醒邮件内容：">
          <html-editor v-model="editForm.payEmailContent" />
        </el-form-item>

        <el-form-item label="支付页面显示内容：">
          <html-editor v-model="editForm.payPageContent" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import StatusSelect from "@/components/StatusSelect";
import HtmlEditor from "@/components/HtmlEditor";
// import { VueEditor } from "vue2-editor";

export default {
  name: "ActConfig",
  components: { MyPagination, StatusSelect, HtmlEditor },
  data() {
    return {
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addFormKey: new Date().getTime(),
      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editFormKey: new Date().getTime(),
      editForm: {},
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    preview(index, row) {
      window.open("https://h5.getnice.app/invite/index.html?actId=" + row.id, "_blank");
    },
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("/api/admin/act-config/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addFormKey = new Date().getTime();
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.form("/api/admin/act-config/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("/api/admin/act-config/" + row.id);
        this.editFormKey = new Date().getTime();
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.form("/api/admin/act-config/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
